<template>
  <router-view />
</template>

<script>
export default {
  name: 'Admin.Servers'
}
</script>

<style scoped>

</style>
